import { render, staticRenderFns } from "./UseDialog.vue?vue&type=template&id=b3f98cfc&scoped=true&"
import script from "./UseDialog.vue?vue&type=script&lang=js&"
export * from "./UseDialog.vue?vue&type=script&lang=js&"
import style0 from "./UseDialog.vue?vue&type=style&index=0&id=b3f98cfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f98cfc",
  null
  
)

export default component.exports